import PerformanceForm from "@/modules/performance/components/form";
import React from "react";
import { useParams } from "react-router-dom";

const UpdateFeedback = () => {
  const { reviewId } = useParams();


  return <PerformanceForm performanceId={reviewId} showEmployee={true} />;
};

export default UpdateFeedback;
